import { FilterOperator } from "features/ui/Filters/types";

import { AnyAll } from "./FilterGroup/AnyAllSelect";
import { FilterGroupState } from "./types";

export const QUICK_FILTERS_WIDTH_CLASS = "w-full max-w-[42rem]";
export const ADVANCED_FILTERS_WIDTH_CLASS = "w-full max-w-[65rem]";

export const FILTER_INDENT_MARGIN_PX = 8;
export const FILTER_INDENT_GROUP_MARGIN_PX = 4;
const FILTER_DEFAULT_ANY_ALL: AnyAll = "all";
export const ANY_FILTER_SEPARATOR = "||";
export const ALL_FILTER_SEPARATOR = ",";

/**
 * We always start with just one top-level group
 * and we do not allow zero rows in a group
 */
export const DEFAULT_FILTER_BUILDER_STATE: FilterGroupState = {
  type: "group",
  id: "group-0",
  anyAll: FILTER_DEFAULT_ANY_ALL,
  children: [],
};

export const DEFAULT_FILTER_BUILDER_STATE_ANY: FilterGroupState = {
  type: "group",
  id: "group-0",
  anyAll: "any",
  children: [],
};

export const FILTER_ROW_OPACITY_PERCENTAGE_INCREASE = 3;

export const SIMPLIFY_FILTER_IGNORED_OPERATORS: FilterOperator[] = [
  FilterOperator.IN_LAST,
  FilterOperator.EXISTS,
  FilterOperator.NOT_EXISTS,
  FilterOperator.OCCURS,
  FilterOperator.NOT_OCCURS,
  FilterOperator.BETWEEN,
  FilterOperator.NOT_FILTERED,
  FilterOperator.MATCH,
];

export const SIMPLIFY_FILTER_MAPPING: Record<FilterOperator, FilterOperator[]> =
  {
    [FilterOperator.IN]: [FilterOperator.IN, FilterOperator.EQUALS],
    [FilterOperator.NOT_IN]: [FilterOperator.NOT_IN, FilterOperator.NOT_EQUALS],
    [FilterOperator.EQUALS]: [FilterOperator.IN, FilterOperator.EQUALS],
    [FilterOperator.NOT_EQUALS]: [
      FilterOperator.NOT_IN,
      FilterOperator.NOT_EQUALS,
    ],
    [FilterOperator.IS_TRUE]: [FilterOperator.IS_TRUE],
    [FilterOperator.IS_FALSE]: [FilterOperator.IS_FALSE],
    [FilterOperator.IS_EMPTY]: [FilterOperator.IS_EMPTY],
    [FilterOperator.IS_NOT_EMPTY]: [FilterOperator.IS_NOT_EMPTY],
    [FilterOperator.GREATER_THAN]: [
      FilterOperator.GREATER_THAN,
      FilterOperator.GREATER_OR_EQUAL,
    ],
    [FilterOperator.GREATER_OR_EQUAL]: [
      FilterOperator.GREATER_OR_EQUAL,
      FilterOperator.GREATER_THAN,
    ],
    [FilterOperator.LESS_THAN]: [
      FilterOperator.LESS_THAN,
      FilterOperator.LESS_OR_EQUAL,
    ],
    [FilterOperator.LESS_OR_EQUAL]: [
      FilterOperator.LESS_OR_EQUAL,
      FilterOperator.LESS_THAN,
    ],
    [FilterOperator.BETWEEN]: [FilterOperator.BETWEEN],
    [FilterOperator.CONTAINS]: [FilterOperator.CONTAINS],
    [FilterOperator.NOT_CONTAINS]: [FilterOperator.NOT_CONTAINS],
    [FilterOperator.MATCH]: [FilterOperator.MATCH],
    [FilterOperator.STARTS_WITH]: [FilterOperator.STARTS_WITH],
    [FilterOperator.NOT_STARTS_WITH]: [FilterOperator.NOT_STARTS_WITH],
    [FilterOperator.IN_LAST]: [FilterOperator.IN_LAST],
    [FilterOperator.EXISTS]: [FilterOperator.EXISTS],
    [FilterOperator.NOT_EXISTS]: [FilterOperator.NOT_EXISTS],
    [FilterOperator.OCCURS]: [FilterOperator.OCCURS],
    [FilterOperator.NOT_OCCURS]: [FilterOperator.NOT_OCCURS],
    [FilterOperator.NOT_FILTERED]: [FilterOperator.NOT_FILTERED],
    [FilterOperator.HAS_ONE_OR_MORE]: [FilterOperator.GREATER_THAN],
    [FilterOperator.HAS_NONE]: [FilterOperator.LESS_OR_EQUAL],
  };
